import { prop } from 'ramda'

export const volume = prop('volume')
export const muted = prop('muted')
export const rate = prop('rate')
